import Countdown, { zeroPad } from 'react-countdown';
import { FormattedMessage, useIntl } from 'react-intl';
import ModalActionCreator from 'action_creators/modal';
import { CheckoutError } from 'views/plugins/global_error/CheckoutError';
import styled from '@emotion/styled';
import { brandNeutralColors } from 'ui_system/compass/utils';

const TimerContainer = styled.div`
  background-color: ${brandNeutralColors.border};
  display: inline-block;
  width: 100%;
  padding: 3px 8px;
`;

const CheckoutTimerText = styled.span`
  color: ${brandNeutralColors.text.primary};
`;

interface checkoutTimerProps {
  sessionExpired: number;
  guideId: number;
  tourId: number;
  originUrl: string;
}
const CheckoutTimer = ({
  sessionExpired,
  guideId,
  tourId,
  originUrl,
}: checkoutTimerProps) => {
  const intl = useIntl();
  const handleTimerComplete = () => {
    const title = intl.formatMessage({
      id: 'TIME_LIMIT_REACHED',
      defaultMessage: 'Time limit reached',
    });
    const message = intl.formatMessage({
      id: 'SORRY_YOUR_BOOKING_HAD_TO_BE_RELEASED_PLEASE_RESTART_YOUR_BOOKING',
      defaultMessage:
        'Sorry, your booking had to be released. Please restart your booking.',
    });
    const buttonUrl =
      window !== window.top ? `/i/${guideId}/c/tours/${tourId}` : originUrl;

    ModalActionCreator.show({
      content: (
        <CheckoutError title={title} message={message} buttonUrl={buttonUrl} />
      ),
      className: 'small GlobalError-Modal-Plugin modal',
      settings: { closable: false },
      showIcon: false,
    });
  };
  return (
    <TimerContainer>
      <Countdown
        date={sessionExpired}
        onComplete={handleTimerComplete}
        renderer={({ minutes, seconds }) => (
          <CheckoutTimerText
            data-testid="timer-content"
            className="checkout-timer-text"
          >
            <FormattedMessage
              id="WE_ARE_HOLDING_YOUR_BOOKING_FOR"
              defaultMessage="We are holding your booking for <strong>{timer}</strong> minutes."
              values={{
                timer: `${zeroPad(minutes)}:${zeroPad(seconds)}`,
                strong: (chunks) => <strong>{chunks}</strong>,
              }}
            />
          </CheckoutTimerText>
        )}
      />
    </TimerContainer>
  );
};

export default CheckoutTimer;
